export default __webpack_public_path__ + "static/logo_zipher-0a70ea939dbc51cc76687992455c64ed.png";